import { cloudFunction } from 'services/parse';

export const fetchAllCategoryGroups = () => {
  return cloudFunction('fetchAllCategoryGroups', {});
};

export const fetchCategoryGroupDetails = (id: string) => {
  return cloudFunction('fetchCategoryGroupDetails', { id });
};

export const updateCategoryGroup = (data: Record<string, any>) => {
  return cloudFunction('updateCategoryGroup', data);
};

export const updateCategoryGroupImage = (id: string, image: Parse.File) => {
  return cloudFunction('updateCategoryGroup', { id, image });
};

export const updateCategoryImage = (id: string, image: Parse.File) => {
  return cloudFunction('updateCategoryImage', { id, image });
};

export const updateCategory = (data: Record<string, any>) => {
  return cloudFunction('updateCategory', data);
};

export const fetchCategoryDetails = (id: string) => {
  return cloudFunction('fetchCategoryDetails', { id });
};

export const toggleCategoryActiveStatus = (id: string) => {
  return cloudFunction('toggleCategoryActiveStatus', { id });
};

export const createCategory = (data: Record<string, any>) => {
  return cloudFunction('createCategory', data);
};